/** English mirror of ./strings.ar.js — DataTables' own English wording. */

export const table = {
  search: 'Search:',
  lengthBefore: 'Show',
  lengthAfter: 'entries',
  zeroRecords: 'No matching records found',
  loadFailed: 'The data could not be loaded',
  processing: 'Processing...',
  info: (start, end, total) => `Showing ${start} to ${end} of ${total} entries`,
  infoEmpty: 'Showing 0 to 0 of 0 entries',
  infoFiltered: (max) => `(filtered from ${max} total entries)`,
  previous: 'Previous',
  next: 'Next',
  pagination: 'Pagination',
}

export const kit = {
  pickerMore: (shown, total) => `Showing ${shown} of ${total} — narrow the search for the rest`,
  pickerChosen: 'departments chosen',
  pickerEmpty: 'No department matches that name',
  back: 'Back',
  nextStep: 'Next',
  previousStep: 'Back',
  close: 'Close',
  confirmDelete: 'Confirm delete',
  confirmByTyping: 'To confirm write down the name',
  copy: 'Copy',
  copied: 'Copied',
  delete: 'Delete',
  cancel: 'Cancel',
  export: 'Export',
  options: 'Options',
  moreInfo: 'More information',
  clearSearch: 'Clear search',
  selectSearch: 'Search…',
  selectNoMatches: 'No matches',
  clearDate: 'Clear date',
  remove: 'Remove',
  chooseFile: 'Choose file',
  noFile: 'No file chosen',
  loading: 'Fetching data from the server',
  listSep: ', ',
}

export const excel = {
  intro: 'Please upload an Excel (.xlsx) or CSV (.csv) file',
  introZip: 'Please upload a ZIP (.zip) archive',
  columnsIntro: 'The file must contain the following columns',
  mandatory: 'Required',
  optional: 'Optional',
  notesTitle: 'Important notes',
  notes: 'Download the template first, and keep the column names and their order exactly as they appear in it.',
  notesZip: 'The archive is what this screen exports from another installation; there is no template to download. A topic whose name already exists is not imported.',
  template: 'Download template',
  save: 'Upload',
  close: 'Close',
  fileRequired: 'Please choose an Excel file',
}

export const notificationStates = {
  Waiting: 'Waiting',
  Running: 'Running',
  Stopped: 'Stopped',
  Finished: 'Finished',
  Failed: 'Failed',
  Succeeded: 'Succeeded',
}

export const notifications = {
  title: 'Notifications',
  details: 'Details',
  preview: 'Preview',
  state: 'Status',
  scheduledOn: 'Scheduled on',
  startDate: 'Start Date',
  endDate: 'End Date',
  recipient: 'Recipient',
  deliveryStatus: 'Delivery',
  tries: 'Attempts',
  error: 'Error',
  noMessages: 'This batch produced no messages.',
  loadFailed: 'The notification history could not be loaded.',
}

export const editor = {
  bold: 'Bold',
  italic: 'Italic',
  underline: 'Underline',
  heading: 'Heading',
  bullets: 'List',
  link: 'Link',
  linkPrompt: 'Link URL',
  clear: 'Clear formatting',
}

export const theme = {
  label: 'Mode',
  light: 'Light',
  dark: 'Dark',
}

export const transport = {
  network: 'Could not reach the server, check your connection and try again',
  networkUpload: 'Could not reach the server while uploading',
  redirected: 'The request could not be completed, please reload the page',
  sessionEnded: 'Your session has ended, please sign in again',
  denied: 'You do not have permission to do this',
  deniedDownload: 'You do not have permission to download this',
  html: 'The server response could not be read, please try again',
  failed: (status) => `Request failed (${status})`,
  uploadFailed: (status) => `Upload failed (${status})`,
}

/** The page-level activation switch's outcome — see strings.ar.js. */
export const feature = {
  enabled: 'Feature activated',
  disabled: 'Feature turned off',
  failed: 'The action could not be completed',
}
